import { Box, Flex, Heading, Link, Tag, Text } from '@chakra-ui/react';
import { CSSObject } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';

interface Props {
  id?: string;
  address?: string;
  maxSuites?: number;
  name?: string;
}

const activeStyles: CSSObject = {
  bg: 'white',
  boxShadow: 'lg',
};

function LocationListItem({ id = '0', address, maxSuites, name }: Props) {
  return (
    <Link
      as={NavLink}
      to={id}
      _hover={{ textDecoration: 'none' }}
      sx={{ '&.active': activeStyles }}
    >
      <Flex
        h="82"
        py={4}
        px={3}
        borderBottom="1px"
        borderColor="gray.200"
        align="center"
        sx={{ 'a:hover &': activeStyles }}
      >
        <FontAwesomeIcon icon={['fal', 'location-dot']} size="2x" color="#A57EF3" />
        <Box flex={1} px={3}>
          <Heading fontSize="small" size="sm" mb={1}>
            {name}
          </Heading>
          <Text fontSize="sm" color="gray.500">
            {address}
          </Text>
        </Box>
        <Box textAlign="right" height="100%">
          <Text fontSize="xs" fontWeight="bold" mb={1}>
            Max Suites
          </Text>
          <Tag size="sm" colorScheme="purple" borderRadius="full">
            {maxSuites}
          </Tag>
        </Box>
      </Flex>
    </Link>
  );
}

export default LocationListItem;
